import { render, staticRenderFns } from "./JobIntakeChat.vue?vue&type=template&id=64d2f110&scoped=true"
import script from "./JobIntakeChat.vue?vue&type=script&lang=js"
export * from "./JobIntakeChat.vue?vue&type=script&lang=js"
import style0 from "./JobIntakeChat.vue?vue&type=style&index=0&id=64d2f110&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d2f110",
  null
  
)

export default component.exports